// extracted by mini-css-extract-plugin
module.exports = {"container":"Multiple_container__2Gepc","icon":"Multiple_icon__10iEj","type_name":"Multiple_type_name__5neRd"};